/* -----------------------------------------------------------------------------------------------------
  - Created: [12-03-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains FinanceDashboard
  -------------------------------------------------------------------------------------------------------
*/

import React, { useContext } from 'react'
import FinanceDashboardCard from './FinanceDashboardComponents/FinanceDashboardCard/FinanceDashboardCard'
import { BsGraphUpArrow } from "react-icons/bs";
import { LuClock4 } from "react-icons/lu";
import { BsCheck2Circle } from "react-icons/bs";
import RevenueGraph from '../DashnoardComponents/DashboardGraph/RevenueGraph';
import { Grid } from '@mui/joy';
import DashboardLineGraph from '../DashnoardComponents/DashboardGraph/DashboardLineGraph/DashboardLineGraph';
import SiteReport from './FinanceDashboardComponents/SiteReport/SiteReport';
import CompletedWork from './FinanceDashboardComponents/CompletedWork/CompletedWork';
import MandaysToBeBilled from './FinanceDashboardComponents/MandaysToBeBilled/MandaysToBeBilled';
import InvoiceProcessingKPI from './FinanceDashboardComponents/InvoiceProcessingKPI/InvoiceProcessingKPI';
import InvoiceAmountStatus from './FinanceDashboardComponents/InvoiceAmountStatus/InvoiceAmountStatus';
import { dashboardContext } from '../Dashboard';
import useScreenSize from '../../../utils/useScreenSize';
import CustomSkelton from '../../../Components/Skeletons/CustomSkelton';
import TextSkeleton from '../../../Components/Skeletons/TextSkeleton';

function FinanceDashboard() {
    const { data, isLoading } = useContext(dashboardContext);
    const { width } = useScreenSize();


    return (
        <>
            <div className="dashboard-header">{isLoading ? <TextSkeleton width='15%' fontSize='3rem' /> : `Dashboard`} </div>
            <div className='dashboard-card-main-container' >
                {isLoading ? (
                    <>
                        <CustomSkelton
                            height={180}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={180}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={180}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={180}
                            width={width > 600 ? '33%' : '100%'}
                        />
                    </>
                ) : (
                    <>
                        <FinanceDashboardCard
                            color1="#567C09"
                            color2="#567C09"
                            image={`11`}
                            title={`Total Revenue`}
                            // subTitle={`12.5%`}
                            count={data?.totalRevanue || `0`}
                            icon={`AED`}
                        // <BiDollar />
                        />

                        <FinanceDashboardCard
                            color1="#006CB8"
                            color2="#006CB8"
                            image={`11`}
                            title={`Monthly Revenue`}
                            // subTitle={`8.5%`}
                            count={data?.monthlyRevanue || `0`}
                            icon={<BsGraphUpArrow />}
                        />
                        <FinanceDashboardCard
                            color1="#A67DFF"
                            color2="#A67DFF"
                            image={`11`}
                            title={`Pending Invoices`}
                            // subTitle={`4 New`}
                            count={data?.unpaidInvoices || `0`}
                            icon={<LuClock4 />}
                        />
                        <FinanceDashboardCard
                            color1="#3E9BFB"
                            color2="#3E9BFB"
                            image={`11`}
                            title={`Completed Invoices`}
                            // subTitle={`+6 Today`}
                            count={data?.paidInvoices || `0`}
                            icon={<BsCheck2Circle />}
                        />
                    </>
                )}

            </div>
            <div className='dashboard-mid-container'>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                        <MandaysToBeBilled />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <InvoiceAmountStatus />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <CompletedWork />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <InvoiceProcessingKPI />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default FinanceDashboard


{/* <RevenueGraph title={`Revenue by worksite`} /> */ }
{/* <SiteReport title={`Latest Report`}/> */ }
{/* <DashboardLineGraph xAxisData={xAxisData} seriesData={seriesData} /> */ }
